import React from 'react';
import { FiInstagram, FiTwitter, FiFacebook, FiDroplet } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  return (
    <footer className="bg-stone-950 text-stone-400 pt-24 pb-12 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-20">
          
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-8 text-white">
              <SafeIcon icon={FiDroplet} className="text-2xl text-teal-500" />
              <span className="font-black text-2xl tracking-tighter">TerraSip</span>
            </div>
            <p className="max-w-sm mb-8 leading-relaxed">
              Premium hydration tools engineered for durability and the circular economy. Join us in closing the loop on single-use plastics.
            </p>
            <div className="flex gap-5">
              <a href="#" className="hover:text-teal-400 transition-colors"><SafeIcon icon={FiInstagram} className="text-xl" /></a>
              <a href="#" className="hover:text-teal-400 transition-colors"><SafeIcon icon={FiTwitter} className="text-xl" /></a>
              <a href="#" className="hover:text-teal-400 transition-colors"><SafeIcon icon={FiFacebook} className="text-xl" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-6">Explore</h4>
            <ul className="space-y-4 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Core Series</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Urban Series</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Replacement Parts</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Gift Cards</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-6">Program</h4>
            <ul className="space-y-4 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">The Refill-Loop</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Impact Report</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Affiliates</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Bulk Orders</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-6">Service</h4>
            <ul className="space-y-4 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Shipping Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Returns & Repairs</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Warranty Registry</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-xs font-medium tracking-wide">
            Made by LingLink AI and DigLab AI
          </div>
          <div className="flex gap-8 text-[10px] uppercase tracking-[0.2em] font-bold">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Accessibility</a>
          </div>
          <div className="text-xs">
            &copy; {new Date().getFullYear()} TerraSip Inc.
          </div>
        </div>
      </div>
    </footer>
  );
}